import { SuburbanHouseTypeContainer } from '../../containers/advancedFilters/SuburbanHouseTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanHouseType: IFilter = {
  component: SuburbanHouseTypeContainer,
};
